export default () => ({
  url: 'https://fin.zapimoveis.com.br/financiamento/simulacao?utm_source=zapimoveis.com.br&utm_medium=referral&utm_campaign=aquisicao',
  iframeUrl: '',
  partner: '',
  avaliablePartner: null,
})
